"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThreeMonths = exports.MobileSwipeContainer = exports.DesktopSwipeRightContainer = exports.DesktopSwipeLeftContainer = exports.DateField = exports.CalendarContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const colors_1 = require("../../../assets/styles/colors");
const media_1 = require("../../../utils/media");
const Typography_1 = require("../../atoms/Typography");
const ThreeMonths = styled_components_1.default.div `
  display: flex;
  justify-content: center;
  gap: 2rem;
  flex-wrap: wrap;

  @media (${media_1.media.desktop}) {
    flex-wrap: nowrap;
  }
`;
exports.ThreeMonths = ThreeMonths;
const MobileSwipeContainer = styled_components_1.default.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  padding: 1.5rem 0;
`;
exports.MobileSwipeContainer = MobileSwipeContainer;
const DesktopSwipeLeftContainer = styled_components_1.default.div `
  position: absolute;
  display: flex;
  left: 3rem;
  top: 25rem;
  transform: translateY(-50%);
`;
exports.DesktopSwipeLeftContainer = DesktopSwipeLeftContainer;
const DesktopSwipeRightContainer = styled_components_1.default.div `
  position: absolute;
  display: flex;
  right: 3rem;
  top: 25rem;
  transform: translateY(-50%);
`;
exports.DesktopSwipeRightContainer = DesktopSwipeRightContainer;
const DateField = (0, styled_components_1.default)(Typography_1.H3) `
  display: flex;
  align-items: center;

  span {
    margin: 0 1.5rem;
  }
`;
exports.DateField = DateField;
const CalendarContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  padding: 1.5rem;
  background: ${colors_1.white};
  position: relative;

  @media (${media_1.media.desktop}) {
    padding: 3.5rem 10rem;
  }
`;
exports.CalendarContainer = CalendarContainer;
